import { useHeader } from '@/layouts/MainLayout/HeaderContext'
import { CookieDialog } from '@/ux/Dialog/CookieDialog'
import { MAIN_HEADER_HEIGHT } from '@/catalog-apps/components/config'
import { ReactComponent as PwcLogo } from '@/assets/svg/pwc__logo_v2.svg'
import { PrivacyPolicyDialog } from './PrivacyPolicyDialog'

export function Footer() {
  const thisYear = new Date().getFullYear()
  const { privacyUrl, coBrandingImageKey, usePrivacyPolicyDialog, privacyPolicyApplicationId } = useHeader()

  return (
    <div
      id="ui-footer"
      style={{ height: `${MAIN_HEADER_HEIGHT}px` }}
      // className="grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-x-4 overflow-hidden border-t border-border/50 bg-offwhite px-4 text-sm leading-relaxed text-foreground shadow-[inset_0_7px_9px_-7px_rgb(0_0_0/35%)] dark:border-border dark:bg-background dark:text-foreground"
      className="grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-x-4 overflow-hidden border-t border-border/50 bg-foreground/10 px-4 text-sm leading-relaxed text-foreground dark:border-border dark:bg-background dark:text-foreground"
    >
      <div className="flex min-h-0 shrink-0 items-center">
        {!!coBrandingImageKey && (
          <div className="flex items-center gap-3">
            <span className="shrink-0 whitespace-nowrap">Powered by:</span>
            <span className="inline-flex shrink-0 items-center justify-center p-2.5">
              <PwcLogo
                className="block aspect-[360/180] h-6 w-12 min-w-[48px] shrink-0 fill-current text-black dark:text-white"
                aria-label="PwC"
                role="img"
              />
            </span>
          </div>
        )}
      </div>

      <p className="min-w-0 text-center">
        &copy; {thisYear} PwC. PwC refers to the PwC network and/or one or more of its member firms, each of which is a
        separate legal entity. Please see{' '}
        <a
          href="https://www.pwc.com/structure"
          target="_blank"
          rel="noreferrer noopener"
          className="underline underline-offset-2"
        >
          www.pwc.com/structure
        </a>{' '}
        for further details.
      </p>

      <div className="flex shrink-0 items-center gap-2 justify-self-end whitespace-nowrap">
        {usePrivacyPolicyDialog ? (
          <>
            <PrivacyPolicyDialog appId={privacyPolicyApplicationId}>
              <button type="button" className="underline underline-offset-2">
                Privacy
              </button>
            </PrivacyPolicyDialog>
            <span aria-hidden className="text-muted-foreground">
              |
            </span>
          </>
        ) : privacyUrl ? (
          <>
            <a href={privacyUrl} target="_blank" rel="noreferrer" className="underline underline-offset-2">
              Privacy
            </a>
            <span aria-hidden className="text-muted-foreground">
              |
            </span>
          </>
        ) : null}
        <a
          href="https://www.pwc.co.za/en/about-us/legal-disclaimer.html"
          target="_blank"
          rel="noreferrer noopener"
          className="underline underline-offset-2"
        >
          Legal
        </a>
        <span aria-hidden className="text-muted-foreground">
          |
        </span>
        <CookieDialog>
          <a className="cursor-pointer underline underline-offset-2">Cookie Info</a>
        </CookieDialog>
      </div>
    </div>
  )
}
